/**
 * Helper condivisi per la presentazione delle partite (Dashboard, MyMatches, …).
 */
import {
  MATCHES_FIELDS,
  SET_FIELDS,
  MATCH_TEAM_FIELDS,
  GROUP_MEMBERS_FIELDS,
  USERS_FIELDS,
} from '../domain/dataModel';

export const MATCH_TYPE_LABELS = { classic: 'Classica', king: 'King', super_king: 'Super King' };

export function resolvePlayerLabel(uid, groupId, membersByGroupId, user, userProfile) {
  if (!uid) return '';
  if (uid === user?.uid) {
    return userProfile?.[USERS_FIELDS.DISPLAY_NAME]?.trim() || user?.email?.split('@')[0] || 'Tu';
  }
  const members = membersByGroupId[groupId] || [];
  const m = members.find((mm) => mm[GROUP_MEMBERS_FIELDS.USER_ID] === uid);
  if (!m) return 'Giocatore';
  if (m[GROUP_MEMBERS_FIELDS.IS_GUEST]) return m[GROUP_MEMBERS_FIELDS.GUEST_NICKNAME]?.trim() || 'Ospite';
  return m[GROUP_MEMBERS_FIELDS.DISPLAY_NAME]?.trim() || 'Giocatore';
}

export function getMatchTeamSides(match, membersByGroupId, user, userProfile) {
  const sets = match[MATCHES_FIELDS.SETS] || [];
  const s0 = sets[0];
  const gid = match.groupId || match[MATCHES_FIELDS.GROUP_ID];
  if (!s0) return { left: '—', right: '—' };
  const t1 = s0[SET_FIELDS.TEAM1] || {};
  const t2 = s0[SET_FIELDS.TEAM2] || {};
  const n = (pid) => resolvePlayerLabel(pid, gid, membersByGroupId, user, userProfile);
  const left = [n(t1[MATCH_TEAM_FIELDS.PLAYER1]), n(t1[MATCH_TEAM_FIELDS.PLAYER2])].filter(Boolean).join(' · ') || '—';
  const right = [n(t2[MATCH_TEAM_FIELDS.PLAYER1]), n(t2[MATCH_TEAM_FIELDS.PLAYER2])].filter(Boolean).join(' · ') || '—';
  return { left, right };
}

export function matchTypeBadgeClass(typeKey) {
  if (typeKey === 'king') return 'border-gold/40 bg-gold/15 text-gold';
  if (typeKey === 'super_king') return 'border-purple-400/40 bg-purple-500/15 text-purple-300';
  return 'border-brand-sky/40 bg-brand-sky/15 text-brand-sky';
}
